import { useState } from 'react'
import { useSelector } from 'react-redux'
import { GrantDetail } from '../../../../../../components/GrantDetail'
import { GrantSelectors } from '../../../../../../store/grant'
import {AddToProjectButton} from '../../../AddToProjectForm'
import { AddToProjectModal } from './AddToProjectModal'

export const Grant = () => {
  const [openModal, setOpenModal] = useState(false)

  const grant = useSelector(GrantSelectors.getGrant)
  
  const { topicId = '' } = grant

  return (
    <>
      <AddToProjectModal itemToAdd={topicId} open={openModal} setOpen={setOpenModal} />

      <GrantDetail
        grant={grant}
        technologyModalHandler={<AddToProjectButton onClick={() => setOpenModal(true)} />}
      />
    </>
  )
}
